import React from 'react';
import { createIcon } from '../../../utils';

const IconTelegram = createIcon({
  viewBox: '0 0 28 28',
  path: (
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M24.602 2.26453L1.51183 11.8747C1.51183 11.8747 0.420164 12.2716 0.504664 13.0035C0.591439 13.7367 1.48226 14.0721 1.48226 14.0721L7.29226 16.1462C7.29226 16.1462 9.04595 22.2471 9.3911 23.408C9.73625 24.5656 10.0131 24.5929 10.0131 24.5929C10.3346 24.7411 10.6267 24.5052 10.6267 24.5052L14.3805 20.8752L20.2308 25.6339C21.8132 26.3661 22.3891 24.8406 22.3891 24.8406L26.5 2.84531C26.5 1.38021 24.602 2.26453 24.602 2.26453ZM20.5142 23.0716L14.2554 17.9821L12.3132 19.8596L12.7402 15.8651L21.0829 7.95818L9.7109 14.7097L4.6666 12.9092L23.912 4.89865L20.5142 23.0716Z"
      fill="#0088CC"
    />
  ),
});

export default IconTelegram;
